<script setup lang="ts">
  import {
    ConfirmationDialog,
    UiButton,
    InputField,
    FormFieldContainer,
  } from '@logistiek-zonder-papier/lzp-library'
  import { computed, ref } from 'vue'

  const model = defineModel<Record<string, string>>({ required: true })
  const pendingDeleteKey = ref<string | null>(null)

  const entries = computed(() => Object.entries(model.value))

  function removeKey() {
    if (pendingDeleteKey.value !== null) {
      const { [pendingDeleteKey.value]: _, ...rest } = model.value
      model.value = rest
      pendingDeleteKey.value = null
    }
  }

  function setValue(key: string, value: string | number) {
    model.value = { ...model.value, [key]: value + '' }
  }
</script>

<template>
  <div class="key-value-list">
    <div v-for="[key, value] in entries" :key="key">
      <FormFieldContainer :label="key.replaceAll('_', ' ')">
        <template #action-button>
          <UiButton
            icon="delete"
            size="small"
            variant="negative"
            @click.prevent="pendingDeleteKey = key"
          />
        </template>
        <InputField
          type="text"
          autofocus
          required
          :placeholder="`Waarde voor ${key.replaceAll('_', ' ')}`"
          :model-value="value"
          @update:model-value="setValue(key, $event ?? '')"
        />
      </FormFieldContainer>
    </div>
    <ConfirmationDialog
      :title="`Are you sure you want to remove item ${pendingDeleteKey}?`"
      body="This action cannot be undone."
      confirmButtonText="Remove"
      confirmButtonColor="negative"
      @update:show="pendingDeleteKey = $event ? pendingDeleteKey : null"
      :show="pendingDeleteKey !== null"
      :confirm="() => removeKey()"
    />
    <p v-if="entries.length === 0" class="empty-state">Nog geen waarden toegevoegd.</p>
  </div>
</template>

<style scoped>
  :deep(.button) {
    padding: 0.5rem;
  }

  .key-value-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .empty-state {
    font-size: 0.8125rem;
    color: var(--colours-grey-4);
    text-align: center;
    padding: 0.5rem 0;
    margin: 0;
  }
</style>
